module.exports = __webpack_public_path__ + "img/gift_jbl_tt_pt.1a525252.jpg";